import type { CoachProfile } from '@efdigital/ll-addon-data/types/coaching/coach-profile';
import { findAllCoachProfiles } from '@efdigital/ll-admin-v2/data/builders/xceed/coach-profiles';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

export type CoachingCoachesIndexModel = {
  coaches: CoachProfile[];
};

export default class CoachingCoachesIndexRoute extends Route<CoachingCoachesIndexModel> {
  @service declare store: Store;

  async model() {
    const coachesResult = await this.store
      .request(findAllCoachProfiles())
      .catch(() => null);

    return {
      coaches: coachesResult?.content.data ?? [],
    };
  }
}
